import { render, staticRenderFns } from "./CalendarViewNoticeBoardEvent.vue?vue&type=template&id=f345407c&scoped=true&"
import script from "./CalendarViewNoticeBoardEvent.vue?vue&type=script&lang=ts&"
export * from "./CalendarViewNoticeBoardEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarViewNoticeBoardEvent.vue?vue&type=style&index=0&id=f345407c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f345407c",
  null
  
)

export default component.exports